<template>
    <label
        class="mag-form-row"
        :for="id"
        :class="{
            disabled,
            highlighted,
            compact: compact > 0,
            ['very-compact']: compact > 1,
        }"
    >
        <span v-if="largeIcon" class="icon-large">
            <slot name="icon"></slot>
        </span>
        <span class="label">
            <span class="label-title">
                <template v-if="!largeIcon">
                    <slot name="icon"></slot>
                </template>
                <slot name="label"></slot>
                <slot></slot>
            </span>
            <span class="caption"><slot name="caption"></slot></span>
        </span>
        <span class="control-container">
            <slot name="control" :id="id" :disabled="disabled"></slot>
        </span>
    </label>
</template>

<script lang="ts" setup>
import { useId } from "@vue/runtime-core";

withDefaults(
    defineProps<{
        highlighted?: boolean;
        largeIcon?: boolean;
        disabled?: boolean;
        compact?: 0 | 1 | 2;
        tag?: keyof HTMLElementTagNameMap;
    }>(),
    {
        compact: 0,
    },
);

defineSlots<{
    label: () => any;
    default: () => any;
    caption: () => any;
    icon: () => any;
    control: (props: { id: string; disabled?: boolean }) => any;
}>();

const id = useId();
</script>

<style lang="scss" scoped>
@use "@/style/mag-layout";

.mag-form-row {
    @extend .mag-form-row-block;
}
</style>
